// @flow
import React from 'react'
import { Error } from 'src/components/Form'

const renderError = ({ meta: { touched, error }, hideArrow }: { meta: any, hideArrow: ?boolean }) =>
  touched && error ? (
    <Error hideArrow={hideArrow}>
      {error || `Oh, you need to insert your info here to continue`}
    </Error>
  ) : (
    false
  )

export default renderError



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/Error.js